import styled from "styled-components";

export const LoginStyled = styled.div`
  width: 100%;
  height: 100%;
  background-image: url("../London_Map.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  overflow-y: hidden;

  display: flex;
  align-items: center;
  justify-content: center;
`;
